angular.module('app')

	.controller('WelcomeController', ['$scope', '$timeout', function WelcomeController ($scope, $timeout)
	{
		var welcome = this;
		var welcomePage = document.getElementById('welcome_page');
	}]);
